// extracted by mini-css-extract-plugin
export default {"modal":"SignupDetails_modal__jka1n","signupDetailsMain":"SignupDetails_signupDetailsMain__2DGNT","signupDetailsBody":"SignupDetails_signupDetailsBody__c5XJ2"};